import * as moment from "moment";

import axios, { AxiosError, AxiosResponse } from "axios";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import { AdHocCalendarAppointmentModel, UpdateTimeNoteAppointmentModel, CreateTimeNoteAppointmentModel } from "../../bookAppointments/models";

import { CreateUpdateTimeNoteAppointmentResult } from "./models";

export class TimeNoteAppointmentsApi {
    private readonly apiUrl = "/api/appointment/timeNote";

    public createTimeNoteAppointment(
        appointment: AdHocCalendarAppointmentModel
    ): Promise<CreateUpdateTimeNoteAppointmentResult> {
        return this.handleCreateUpdateRequest(appointment, data => axios.post(this.apiUrl, data));
    }

    public updateTimeNoteAppointment(
        timeNoteId: string,
        clinicId: string | undefined,
        appointment: AdHocCalendarAppointmentModel
    ): Promise<CreateUpdateTimeNoteAppointmentResult> {
        const baseUrl = clinicId === undefined ? "/api" : `/api/clinic/${clinicId}`;
        return this.handleCreateUpdateRequest(appointment, data => axios.put(`${baseUrl}/timeNote/${timeNoteId}`, data));
    }

    private async handleCreateUpdateRequest(
        appointment: AdHocCalendarAppointmentModel,
        apiFunc: (data: ServerModelWithDateStrings<UpdateTimeNoteAppointmentModel | CreateTimeNoteAppointmentModel>) => Promise<AxiosResponse<any>>
    ): Promise<CreateUpdateTimeNoteAppointmentResult> {
        const startString = appointment.start.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
        const endString = appointment.end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
        const { teamPreventUsers, ...appointmentModel } = appointment;
        const data = {
            ...appointmentModel,
            appointmentStartTime: startString,
            appointmentEndTime: endString,
            extendTillDay: appointment.extendTillDay?.format(moment.HTML5_FMT.DATE),
            clinicianIds: teamPreventUsers.map(u => u.id)
        };
        try {
            const result = await apiFunc(data);
            return {
                success: true,
                appointment: result.data
            };
        } catch (ex) {
            const axiosError = ex as AxiosError<{ userClashIds: Record<string, string> }>;
            if (axiosError.response && axiosError.response.status && axiosError.response.status === 400) {
                const { ...userClashIds } = axiosError.response.data;
                return { success: false, errors: { userClashIds: Object.keys(userClashIds) } };
            }

            throw axiosError;
        }
    }
}
